import { detectRegionFromUrl } from '../commonUtils'

const REGIONAL_CONFIG_KEY = 'regionalConfig'

export const getRegionParam = (): string | undefined => {
  try {
    const region = detectRegionFromUrl()
    const raw = localStorage.getItem(REGIONAL_CONFIG_KEY)
    const regionalConfig = raw ? (JSON.parse(raw) as Record<string, string>) : {}
    if (region && regionalConfig[region]) return regionalConfig[region]
  } catch {
    // Ignore parse errors
  }
}
